import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from "reactstrap";
// core components
import { addUserInfo } from "../../../actions/auth";
import { connect } from "react-redux";
import AuthService from "../../../services/authService";
import { withRouter } from "react-router";
import NotificationAlert from "react-notification-alert";

function mapDispatchToProps(dispatch) {
  return {
    addUserInfo: (userInfo) => dispatch(addUserInfo(userInfo)),
  };
}

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      roleList: [],
      showPassword: false,
      focusedEmail: false,
      focusedPassword: false,
      showForgotPassword: false, // <-- new state
      forgotEmail: "", // <-- for forgot password form
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleForgotChange = this.handleForgotChange.bind(this);
    this.handleForgotSubmit = this.handleForgotSubmit.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { username, password } = this.state;
    AuthService.login(username, password)
      .then((response) => {
        // On success, reset the state and store tokens
        this.setState({
          username: "",
          password: "",
          roleList: [],
          showPassword: false,
        });

        const { accessToken, roleList, fullName, permissionList, userId, tenant } =
          response;
        localStorage.setItem("CLASHMATE_ACCESS_TOKEN", accessToken);
        localStorage.setItem("userId", userId);
        localStorage.setItem("tenant", tenant);
        localStorage.setItem("CLASHMATE_ROLE_LIST", JSON.stringify(roleList));
        localStorage.setItem(
          "CLASHMATE_PERMISSION_LIST",
          JSON.stringify(permissionList)
        );

        this.props.addUserInfo({ username, roleList, fullName });

        // Switch-case logic to redirect based on role
        switch (String(roleList)) {
          case "ROLE_SUPER_ADMIN":
          case "ROLE_TENANT_ADMIN":
          case "ROLE_LEVEL1":
          case "ROLE_LEVEL2":
          case "ROLE_LEVEL3":
          case "ROLE_ADMIN":
            this.props.history.push("/crm/dashboard");
            break;
          case "ROLE_STARTER":
            this.props.history.push("/");
            break;
          case "ROLE_BASIC":
          case "ROLE_ADVANCE":
          case "ROLE_PRO":
          case "ROLE_BUISNESS":
            this.props.history.push("/user/dashboard");
            break;
          case "ROLE_FREE":
            this.props.history.push("/user/drive/shared");
            break;
          default:
            this.props.history.push("/");
            break;
        }
      })
      .catch((error) => {
        // Handle any errors that occur during the login process
        console.error("Login error:", error);
      });
  }

  handleForgotChange(event) {
    this.setState({ forgotEmail: event.target.value });
  }

  handleForgotSubmit(event) {
    event.preventDefault();
    // TODO: Implement forgot password logic here (API call)
    // For now, just show a notification
    AuthService.forgotPassword({ email: this.state.forgotEmail })
      .then((response) => {
        this.setState({
          forgotPasswordResponse:
            "An email has been sent to you, please check the instructions to reset your password!",
        });
        this.setState({ forgotEmail: "" });
        setTimeout(() => {
          this.setState({
            forgotPasswordResponse: "",
            forgotPasswordError: "",
          });
        }, 3000);
      })
      .catch((error) => {
        this.setState({
          forgotPasswordError:
            "Failed to send reset email. Please try again later.",
        });
        setTimeout(() => {
          this.setState({
            forgotPasswordResponse: "",
            forgotPasswordError: "",
          });
        }, 3000);
      });
  }

  toggleForm() {
    this.setState((prevState) => ({
      showForgotPassword: !prevState.showForgotPassword,
    }));
  }

  notify = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  render() {
    const { username, password, showForgotPassword, forgotEmail } = this.state;
    return (
      <>
        <Row className="justify-content-center">
          <div className="rna-wrapper">
            <NotificationAlert ref="notificationAlert" />
          </div>
          <Col lg="12" md="12">
            <Card className="bg-secondary border-0 mb-0">
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <h3>{showForgotPassword ? "Forgot Password" : "Sign in"}</h3>
                </div>
                {!showForgotPassword ? (
                  <>
                    <Form role="form" onSubmit={this.handleSubmit}>
                      <FormGroup
                        className={classnames("mb-3", {
                          focused: this.state.focusedEmail,
                        })}
                      >
                        <InputGroup className="input-group-merge input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-email-83" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            name="username"
                            placeholder="Email"
                            type="email"
                            onFocus={() =>
                              this.setState({ focusedEmail: true })
                            }
                            onBlur={() =>
                              this.setState({ focusedEmail: false })
                            }
                            onChange={this.handleChange}
                            value={username}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup
                        className={classnames({
                          focused: this.state.focusedPassword,
                        })}
                      >
                        <InputGroup className="input-group-merge input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-lock-circle-open" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            name="password"
                            placeholder="Password"
                            type={this.state.showPassword ? "text" : "password"}
                            onFocus={() =>
                              this.setState({ focusedPassword: true })
                            }
                            onBlur={() =>
                              this.setState({ focusedPassword: false })
                            }
                            onChange={this.handleChange}
                            value={password}
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="secondary"
                              outline
                              onClick={() =>
                                this.setState({
                                  showPassword: !this.state.showPassword,
                                })
                              }
                            >
                              <i
                                className={
                                  this.state.showPassword
                                    ? "fa fa-eye-slash"
                                    : "fa fa-eye"
                                }
                              />
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>
                      <div className="text-center">
                        <Button className="my-4" color="default" type="submit">
                          Sign in
                        </Button>
                      </div>
                    </Form>
                    <div className="text-center">
                      <span onClick={this.toggleForm}>
                        Forgot Password? &nbsp;
                        <span
                          style={{
                            cursor: "pointer",
                            color: "#007bff",
                            textDecoration: "underline",
                          }}
                        >
                          Reset Here
                        </span>
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <Form role="form" onSubmit={this.handleForgotSubmit}>
                      <FormGroup className="mb-3">
                        <InputGroup className="input-group-merge input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-email-83" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            name="forgotEmail"
                            placeholder="Enter your email"
                            type="email"
                            onChange={this.handleForgotChange}
                            value={forgotEmail}
                            required
                          />
                        </InputGroup>
                      </FormGroup>
                      <div className="text-center">
                        <Button className="my-4" color="default" type="submit">
                          Reset
                        </Button>
                      </div>
                    </Form>
                    <div className="text-center">
                      <span
                        style={{
                          cursor: "pointer",
                          color: "#007bff",
                          textDecoration: "underline",
                        }}
                        onClick={this.toggleForm}
                      >
                        Login
                      </span>
                    </div>
                    <div className="text-center">
                      <span style={{ color: "green" }}>
                        {this.state.forgotPasswordResponse}
                      </span>
                      <span style={{ color: "red" }}>
                        {this.state.forgotPasswordError}
                      </span>
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

const LoginForm = connect(null, mapDispatchToProps)(Login);

export default withRouter(LoginForm);
